import type { Question, Submission } from '@l2u/ui/lib/types.ts';
import { isDocumentsTabDocument } from '@l2u/ui/lib/documentsTab.ts';

/**
 * A compliance document is one whose question is flagged to appear in
 * Compliance Documents (include_in_compliance_documents, migration 0031) AND
 * whose submission has been approved by a reviewer — i.e. marked compliant.
 * Until approval the document stays in the questionnaire view, not the
 * compliance-documents view. Used by both the vendor Compliance Documents page
 * and the admin Compliance Documents tab (the admin expresses the same rule via
 * an approvedIds set — see companyDetailTabs.ts).
 *
 * Delegates to isDocumentsTabDocument (@l2u/shared/documentsTab), the one
 * definition of the Documents-tab set, which the API shares.
 */
export function isApprovedComplianceDoc(
  question: Pick<Question, 'include_in_compliance_documents'> | undefined,
  submission: Pick<Submission, 'status' | 'reverify_requested_at'> | undefined,
): boolean {
  return isDocumentsTabDocument(question, submission);
}

/**
 * Keep only submissions that are approved compliance documents (see
 * isApprovedComplianceDoc). Submissions whose question is unknown are dropped
 * (the flag can't be verified).
 */
export function complianceFilteredSubmissions(
  submissions: Submission[],
  questionById: Map<string, Question>,
): Submission[] {
  return submissions.filter((s) => isApprovedComplianceDoc(questionById.get(s.question_id), s));
}
